import { render, staticRenderFns } from "./capture.vue?vue&type=template&id=0e2e2718"
import script from "./capture.vue?vue&type=script&lang=js"
export * from "./capture.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e2e2718')) {
      api.createRecord('0e2e2718', component.options)
    } else {
      api.reload('0e2e2718', component.options)
    }
    module.hot.accept("./capture.vue?vue&type=template&id=0e2e2718", function () {
      api.rerender('0e2e2718', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/emc/avatar/capture.vue"
export default component.exports